import 'whatwg-fetch';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
// import registerServiceWorker from './registerServiceWorker';

import { unregister } from './registerServiceWorker';
unregister();

window.donationUrl = 'https://donation-api.worldvision.org.ph/api/v1/';

// if (process.env.NODE_ENV === "development") {
//     window.donationUrl = 'http://sponsorship-api.test/api/v1/';
    
// }

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
